import Component from '@glimmer/component'
import { KidsSafe } from 'teacher-ui-client/components/footer-main/kids-safe'
import { ScrollToTop } from 'teacher-ui-client/components/footer-main/scroll-to-top'
import { Partner } from 'teacher-ui-client/components/footer-main/partner'
import { SocialLinks } from 'teacher-ui-client/components/footer-main/social-links'
import { FooterNav } from 'teacher-ui-client/components/footer-main/nav'
import { SubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'
import { Copyright } from 'teacher-ui-client/components/footer-main/copyright'

const privacyUrls: Record<string, string> = {
  US: 'https://readingeggs.com/privacy',
  CA: 'https://readingeggs.com/privacy',
  KR: 'https://readingeggs.com/privacy',
}

const aboutUrls: Record<string, string> = {
  US: 'https://readingeggs.com/about',
  CA: 'https://readingeggs.com/about',
  NZ: 'https://readingeggs.co.nz/about',
  KR: 'https://www.abceggs.co.kr/',
}

interface Signature {
  Element: HTMLElement
  Args: {
    countryCode: string
  }
}

export class FooterReading extends Component<Signature> {
  get aboutUrl() {
    return aboutUrls[this.args.countryCode] ?? 'https://readingeggs.com.au/about'
  }

  get privacyUrl() {
    return privacyUrls[this.args.countryCode] ?? 'https://readingeggs.com.au/privacy'
  }

  <template>
    <footer
      class="footer-main-bg-image-reading bg-watermelony-red-350 flex flex-none pt-3 pb-2 print:hidden"
      ...attributes
    >
      <div class="w-1/4 text-right">
        <SocialLinks @subscriptionType={{SubscriptionType.Reading}} @countryCode={{@countryCode}} />
        <Partner @subscriptionType={{SubscriptionType.Reading}} />
      </div>

      <div class="w-1/2 text-center">
        <FooterNav @aboutUrl={{this.aboutUrl}} @privacyUrl={{this.privacyUrl}} />
        <Copyright class="mt-3" @subscriptionType={{SubscriptionType.Reading}} />
      </div>

      <div class="w-1/4 text-left">
        <ScrollToTop class="mb-2" />
        <KidsSafe />
      </div>
    </footer>
  </template>
}

export default FooterReading
